import ColorTokensType from '../Settings/colorTypes';

export type ColorType = keyof typeof lightColors;

const lightColors: ColorTokensType = {
  //#region Universal
  white: '#',

  //#region Base - Used for static backgrounds and borders
  surface: '#FAFAFA',
  decorationBackgroundOne: '#F1F3F3',
  decorationSubtle: '#B3B3B7',
  decorationEmphasized: '#B0C4C2',
  inverse: '#2A2E33',
  //#endregion

  //#region Text and icon
  onSurface: '#1B1F1F',
  onElevation: '#1B1F1F',
  onSurfaceSubtle: '#6E747B',
  onSurfaceSubtleSecondary: '#6E747B',
  onInteractivePrimary: '#F1F3F3',
  onInteractiveSecondary: '#353F3E',
  onInteractiveEmphasized: '#353F3E',
  onInverse: '#FAFAFA',
  onStatic: '#1B1F1F',
  onWarning: '#F1F3F3',
  //#endregion

  //#region Semantic
  semanticSuccess: '#185c3c',
  semanticInformative: '#00629E',
  semanticError: '#c83a3a',
  semanticWarning: '#d23f00',
  semanticWarningHover: '#922C00',
  semanticWarningPressed: '#752300',
  //#endregion

  //#region Elevation
  elevateOne: '#FAFAFA',
  elevateTwo: '#FDFDFD',
  elevateThree: '#FFFFFF',
  overlayOne: '#FFFFFFB3',
  underlayOne: '#00000066',
  //#endregion
  //#region Interactive primary background
  interactivePrimaryBackgroundDefault: '#505E5D',
  interactivePrimaryBackgroundHover: '#374544',
  interactivePrimaryBackgroundPressed: '#1D2B2A',
  //#endregion

  //#region Interactive Secondary background
  interactiveSecondaryBackgroundDefault: 'transparent',
  interactiveSecondaryBackgroundHover: '#F5F5F5',
  interactiveSecondaryBackgroundPressed: '#EDF1EE',
  //#endregion

  //#region Interactive Emphasised background
  interactiveEmphasizedBackgroundDefault: '#FBBFAB',
  interactiveEmphasizedBackgroundHover: '#F9A78B',
  interactiveEmphasizedBackgroundPressed: '#F89A7B',
  //#endregion

  //#region Interactive Subtle background
  interactiveSubtleBackgroundDefault: '#8C9299',
  interactiveSubtleBackgroundHover: '#81868D',
  interactiveSubtleBackgroundPressed: '#7B8087',
  //#endregion

  //#region Interactive Border
  interactiveBorderActive: '#036B63',
  interactiveBorderActiveInverse: '#84CAC3',
  interactiveBorderSecondaryDefault: '#6A7E7C',
  interactiveBorderSecondaryHover: '#4A5656',
  interactiveBorderSecondaryPressed: '#2F3737',
  interactiveBorderSelected: '#151818',
  interactiveBorderInverse: '#CED8D7',
  //#endregion

  // Gradient Opacity
  decorationGradientOpacity:
    'linear-gradient(181.09deg, rgba(255, 255, 253, 0) 0.93%, #FFFFFD 74.53%)',

  //#region Interactive Disabled
  interactiveDisabledOne: '#D3D3D3',
  interactiveDisabledTwo: '#919191',
  //#endregion

  //#region Static colors
  staticBrand1: '#C0D3D5',
  staticBrand2: '#FBBFAB',
  staticWhite: '#FFFFFF',
  staticBlack: '#000000',
  //#endregion

  //#region Link
  linkDefault: '#036B63',
  linkHover: '#0D3835',
  //#endregion
};

export default lightColors;
